var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"currency"}},[(_vm.hideDataNoPlanUser)?_c('div',[_c('UpgradeIcon',{attrs:{"size":18,"tooltipText":_vm.$t('views.common.upgradeIcon.hideDataNoPlanUser')}})],1):_c('div',{class:{
      'softRed--text': !_vm.hideValue && _vm.textRed,
      'softGreen--text': !_vm.hideValue && _vm.textGreen,
      strong: _vm.strong,
      blurred: _vm.hideValue,
    }},[_vm._v(" "+_vm._s(_vm.valueAsString)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }